import { CaseDetailsFlagFlagType } from '@acre/graphql'

export const messagePrefixNote = 'cases.flags.note'
const messagePrefixFlags = 'cases.compliance.flags'

export const flagToMessage = (flag: CaseDetailsFlagFlagType) => {
  return `${messagePrefixFlags}.${flag}`
}
